<template>
  <div>
    <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="字段名称">
            <a-input v-model="searchForm.field_name" allowClear placeholder="请输入字段名称" style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="状态">
            <a-select v-model="searchForm.field_state" allowClear show-search option-filter-prop="children" placeholder="请选择" style="width: 100%">
              <a-select-option v-for="item in TEMPLATE_STATE" :key="item.key" :value="item.key">{{ item.value }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-button type="primary" icon="search" style="margin-right:10px" @click="handleSearch">查询</a-button>
          <a-button type="primary" icon="delete" class="btn-color-warning" @click="handleClear">清空</a-button>
        </a-col>
      </a-row>
    </a-form>

    <div class="content-wrapper">
      <div class="tabs-wrapper">
        <a-tabs v-model="searchForm.data_type" @change="changeTab">
          <a-tab-pane v-for="item in TEMPLATE_TYPE" :key="item.key" :tab="item.value"></a-tab-pane>
        </a-tabs>
        <a-button class="add-btn" v-show="searchForm.data_type === 3" type="primary" @click="addField" icon="plus-circle">添加字段</a-button>
      </div>
      <!-- 表格 -->
      <a-table size="middle" row-key="field" :loading="loading" :data-source="data" :columns="columns" :pagination="pagination" style="margin-top: 20px" @change="handleTableChange">
        <template slot="action" slot-scope="text, record">
          <a-space>
            <a-button type="text" size="small" @click="handleEdit(record)" :disabled="record.field_class == 1" >编辑</a-button>
            <a-button :type="record.field_state == 1 ? 'danger' : 'primary'" size="small" @click="handleChangeState(record)" :disabled="record.field_class == 1" >
              {{ Number(record.field_state) === 1 ? '禁用': '启用' }}
            </a-button>
          </a-space>
        </template>
      </a-table>
    </div>

    <addField ref="addField" :activeTab="searchForm.data_type" @ok="getList" />
  </div>
</template>
<script>
import { reactive, computed, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { searchForm, columns } from './business/constantsList'
import pagination from '@/composables/pagination'
import compuedFun from '../../computed/'
import api from '@/api/'
import addField from './addField'

export default {
  components: { addField },

  setup(props) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      searchForm: { ...searchForm },
      columns,
      form: _this.$form.createForm(_this),
    })

    onMounted(() => {
      methods.getList()
    })

    const methods = {
      // 获取列表
      async getList() {
        _this.loading = true
        // const res = await api.fieldListTemplate(state.searchForm).finally(() => {
          const searchParams = {
            ...state.searchForm,
            page: _this.pagination.current,
            per_page: _this.pagination.pageSize
          }
        const res = await api.filedListTemplate(searchParams).finally(() => {
          _this.loading = false
        })
        const { list, pagination } = res.data
        _this.pagination.total = pagination.total
        _this.data = list
      },

      // 查询搜索
      handleSearch() {
        _this.pagination.current = 1
        _this.getList()
      },

      // 清除
      handleClear() {
        const data_type = state.searchForm.data_type
        state.searchForm = { ...searchForm, data_type }
        _this.getList()
      },

      addField() {
        _this.$refs.addField.open()
      },

      changeTab(val) {
        _this.pagination.current = 1
        _this.getList()
      },

      handleEdit(row) {
        _this.$refs.addField.open(row)
      },

      handleChangeState(row) {
        // 字段状态 1启用 2禁用
        const { id, field_state } = row
        const _field_state = Number(field_state) === 1 ? 2 : 1
        this.$confirm({
          title: `确定要${_field_state === 1 ? '启用' : '禁用'}吗？`,
          okText: '确认',
          cancelText: '取消',
          onOk: async () => {
            const postParams = {
              id,
              field_state: _field_state
            }
            const { code } = await api.updateStateFields(postParams)
            if (code === '000000') {
              this.$message.success('操作成功')
              _this.getList()
            }
          },
          onCancel() {
          }
        })
      }
    }

    return {
      ...toRefs(state),
      ...compuedFun(),
      ...pagination(),
      ...methods
    }
  }
}
</script>
<style lang='less' scoped>
.content-wrapper{
  .tabs-wrapper{
    position: relative;
    /deep/.ant-tabs-nav-wrap{
      .ant-tabs-nav-scroll{
        display: flex;
        justify-content: center;
      }
    }
    .add-btn{
      position: absolute;
      left: 0;
      top: 7px;
    }
  }
}
</style>
